var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.privacy)?_c('div',[_c('h3',[_vm._v("Last Revised: "+_vm._s(_vm.privacy.date))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.privacy.text)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }